// extracted by mini-css-extract-plugin
export default {"message":"deduction_message__6YYpD","appear":"deduction_appear__t1lBT","credit":"deduction_credit__cdbAU","appearNow":"deduction_appearNow__6EbBe"};